import AreaApi from '@/api/area'
export function beforeAddTask() {
	AreaApi.config(['festival_begin', 'festival_end']).then((res: any) => {
		const now = new Date()
		const start = new Date(res.data.festival_begin)
		const end = new Date(res.data.festival_end)
		// const start = new Date('2022/01/11 00:00:00')
		// const end = new Date('2022/01/18 23:59:59')
		// @ts-ignore
		const that: any = this
		if (now >= start && now <= end && that.$refs.sprModal) {
			return (that.$refs.sprModal as any).show()
		}
		return Promise.resolve()
	})
}

export function getList(map: any) {
	let arr: any = []
	for (const item in map) {
		arr = arr.concat(map[item])
	}
	return arr
}

export function getMap(list: any) {
	const map: any = {}
	for (const item of list) {
		if (!map[item.type]) {
			map[item.type] = []
		}
		map[item.type].push(item)
	}
	return map
}

export function getTaskType(row: any, setting: any) {
	// 获取订单类型
	let res =
		setting.injuredTasktypeMap[row.taskType] ||
		setting.surveryTasktypeMap[row.taskType] ||
		setting.conciliationTasktypeMap[row.taskType]

	if (row.subTaskType && setting.subTasktypeMap[row.subTaskType]) {
		res += `-${setting.subTasktypeMap[row.subTaskType]}`
	}
	return res
}

export function getOrderNum(map: any, type: any) {
	if (map[type] && map[type].length) {
		const len = map[type].length
		return (map[type][len - 1].orderNum || 1) + 1
	} else {
		return 1
	}
}
